import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/puntgenie/images/logo.svg';

export default function index() {
  return <Image src={footerLogo} maxH="50px" ml={['0', null, '4']} />;
}
